export default "__VITE_ASSET__40ecc367__"